import { createTheme } from '@mui/material/styles';
import { colors } from '@constants/colors';

// Custom spacing removed as it's not compatible with Material-UI theme

const baseTheme = {
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
        },
      },
    },
  },
};

export const createAppTheme = (isDarkMode: boolean) => {
  return createTheme({
    ...baseTheme,
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: isDarkMode ? colors.brand.primary : '#4f46e5', // Dark blue for dark mode, indigo for light mode
        dark: isDarkMode ? '#1a1f38' : '#3730a3', // Darker shade for hover
        contrastText: '#ffffff', // White text for both modes
      },
      secondary: {
        main: isDarkMode ? colors.brand.secondary : '#6b7280', // White for dark mode, gray for light mode
        dark: isDarkMode ? '#e5e7eb' : '#4b5563', // Darker shade for hover
        contrastText: isDarkMode ? colors.text.secondary : '#ffffff', // Dark text for dark mode, white for light mode
      },
      background: {
        default: isDarkMode ? '#0f0f23' : colors.background.secondary,
        paper: isDarkMode ? '#1a1a2e' : colors.background.card,
      },
      text: {
        primary: isDarkMode ? colors.text.primary : colors.text.secondary,
        secondary: isDarkMode ? colors.text.light : colors.text.dark,
      },
      action: {
        hover: isDarkMode
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(79, 70, 229, 0.04)',
        selected: isDarkMode
          ? 'rgba(79, 70, 229, 0.2)'
          : 'rgba(79, 70, 229, 0.08)',
        disabled: isDarkMode
          ? 'rgba(255, 255, 255, 0.3)'
          : 'rgba(0, 0, 0, 0.26)',
        disabledBackground: isDarkMode
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.12)',
      },
      success: {
        main: '#10b981',
        light: '#34d399',
        dark: '#059669',
        contrastText: '#ffffff',
      },
      error: {
        main: '#ef4444',
        light: '#f87171',
        dark: '#dc2626',
        contrastText: '#ffffff',
      },
      warning: {
        main: '#f59e0b',
        light: '#fbbf24',
        dark: '#d97706',
        contrastText: '#ffffff',
      },
      info: {
        main: '#3b82f6',
        light: '#60a5fa',
        dark: '#2563eb',
        contrastText: '#ffffff',
      },
    },
    typography: {
      ...baseTheme.typography,
      allVariants: {
        color: isDarkMode ? colors.text.primary : colors.text.secondary,
      },
    },
  });
};

// Default theme (light mode)
export const theme = createAppTheme(false);
